import Logo from "../images/nodata.png";
const rutRegex = require("rut-regex");
const Moment = require("moment");

const validaciones = {
  noDataDOMElement: (config, msg) => {
    const div = document.createElement("div");
    div.className = `no-data-image ${config && config.addClass}`;
    const img = document.createElement("img");
    img.className = "image-info";
    img.src = Logo;
    div.appendChild(img);
    const span = document.createElement("span");
    span.textContent = msg;
    span.className = "text";
    div.appendChild(span);
    return div;
  },
  urlValidacion: (uri) => {
    const re = /^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/;
    return re.test(uri);
  },
  emptyText: (textfield) => {
    if (!textfield || textfield.trim() === "") {
      return false;
    }
    return true;
  },
  validarEmail(valor) {
    if (
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
        valor
      )
    ) {
      return true;
    }
    return false;
  },
  cleanRut(rut) {
    return typeof rut === "string"
      ? rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase()
      : "";
  },

  formatRut(rut, { showDots, showHyphen }) {
    rut = this.cleanRut(rut);
    if (!showDots && !showHyphen) return rut;
    var result = "";
    if (showHyphen) {
      result = `${rut.slice(-4, -1)}-${rut.substr(rut.length - 1)}`;
    }
    for (let i = 4; i < rut.length; i += 3) {
      result = rut.slice(-3 - i, -i) + (showDots ? "." : "") + result;
    }
    return result;
  },
  validateRut(rut) {
    //  from rut.js
    if (typeof rut !== "string") {
      return false;
    }
    if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
      return false;
    }

    rut = this.cleanRut(rut);

    let t = parseInt(rut.slice(0, -1), 10);
    let m = 0;
    let s = 1;

    while (t > 0) {
      s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
      t = Math.floor(t / 10);
    }

    const v = s > 0 ? `${s - 1}` : "K";
    return v === rut.slice(-1);
  },
  verifcarRut(data) {
    const rexp = new RegExp(/^([0-9])+-([kK0-9])+$/);
    if (rexp.test(data)) {
      return rutRegex({ exact: true, dot: false }).test(data);
    }
    return false;
  },
  validateSeieCI: (data) => {
    const strongRegex = new RegExp("^([aA-zZ0-9]){9,10}$");
    if (strongRegex.test(data)) {
      return true;
    }
    return false;
  },
  validateCellPhone: (data) => {
    const rexp = new RegExp(/^(\+?56)?(\s?)(0?9)(\s?)[9876543]\d{7}$/);
    if (rexp.test(data)) {
      return true;
    }
    return false;
  },

  validatePhone: (data) => {
    const rexp = new RegExp(/^(\D|\-)*(\d{9})$/);
    if (rexp.test(data)) {
      return true;
    }
    return false;
  },

  getDateFormat: (date) => {
    try {
      return date ? new Date(date) : new Date();
    } catch (error) {
      throw error;
    }
  },
  sendDateFormatApis: (date) => {
    try {
      const HoraMinutosInicio = "00:00:00";
      const soloFechaInicio = Moment(date).format("YYYY-MM-DD");
      const fechaInicio = Moment(
        `${soloFechaInicio} ${HoraMinutosInicio}`,
        "YYYY-MM-DD HH:mm:ss"
      ).format("YYYY-MM-DDTHH:mm:ss");
      const fechasApi = fechaInicio;
      return fechasApi;
    } catch (error) {
      throw error;
    }
  },
  storngPasswordPattern: (password) => {
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-#?!@$%^&*,.()+:;<>=[^_`{}|~'/])(?=.{8,})"
    );
    if (strongRegex.test(password)) {
      return true;
    }
    return false;
  },

  isEmpty: (obj) => {
    // null and undefined are "empty"
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    if (obj == null) return true;
    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;
    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (const key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  },

  getFirstLetter: (text) => {
    if (text) {
      const letter = text.charAt(0);
      return letter.toUpperCase();
    }
    return "";
  },
  removeCharacters: (text, number) => {
    if (text) {
      const letter = text.substr(number);
      return letter.toUpperCase();
    }
    return "";
  },
  isSameDay: (dateToCheck, actualDate) =>
    dateToCheck.getDate() === actualDate.getDate() &&
    dateToCheck.getMonth() === actualDate.getMonth() &&
    dateToCheck.getFullYear() === actualDate.getFullYear(),
  capitalizeFirstLetter: (string) =>
    string.charAt(0).toUpperCase() + string.slice(1),
  calculoMeses: (fechaContrato, fechaUltimoReposo) => {
    const result = {};

    Moment.locale("es");

    const fc = Moment(fechaContrato);

    const fs = Moment(fechaUltimoReposo);

    let fechaIni;
    const fechaFin = Moment(Moment(fs.format()).subtract(1, "months"));
    const duration = fs.diff(fc, "months");

    if (duration > 0) {
      result.middleStepsEnabled = true;
      if (duration >= 3) {
        result.numeroMeses = 3;
        // Busco los ultimos tres meses desde el siniestro hacia atras
        fechaIni = Moment(Moment(fs.format()).subtract(3, "months"));
      } else {
        // Busco los ultimos "durations" meses del siniestro hacia atras
        result.numeroMeses = duration;
        fechaIni = Moment(Moment(fs.format()).subtract(duration, "months"));
      }
    } else {
      // Busco el mes anterior
      result.numeroMeses = 0;
      result.middleStepsEnabled = false;
      fechaIni = Moment(Moment(fs.format()).subtract(1, "months"));
    }

    const timeValues = [];
    const dateValues = [];
    while (
      fechaFin > fechaIni ||
      fechaIni.format("M") === fechaFin.format("M")
    ) {
      timeValues.push(
        fechaIni.format("MMMM").charAt(0).toUpperCase() +
          fechaIni.format("MMMM").slice(1)
      );
      dateValues.push(fechaIni.format("MMYYYY"));
      fechaIni.add(1, "month");
    }

    result.MesesDate = dateValues;
    result.Meses = timeValues;
    return result;
  },

  formatDataMomment: (date) => {
    Moment.locale("es");
    const fc = Moment(date, "DD-MM-YYYY").format("DD/MM/YYYY");
    return fc;
  },

  accentValidator: (text) => {
    const find = [
      "Ã",
      "Ã©",
      "Ã¡",
      "Ã³",
      "Ãº",
      "Ã±",
      "Ã",
      "Ã‰",
      "Ã",
      "Ã“",
      "Ãš",
      "Ã‘",
    ];
    const replace = [
      "í",
      "é",
      "á",
      "ó",
      "ú",
      "ñ",
      "Á",
      "É",
      "Í",
      "Ó",
      "Ú",
      "Ñ",
    ];
    const result = validaciones.replaceStr(text, find, replace);
    return result;
  },

  replaceStr: (str, find, replace) => {
    for (let i = 0; i < find.length; i++) {
      str = str.replace(new RegExp(find[i], "gi"), replace[i]);
    }
    return str;
  },
  getUnique: (arr, comp) => {
    const unique = arr
      .map((e) => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  },
  compareDates: (dateIni, dataEnd) => {
    Moment.locale("es");
    const fini = Moment(dateIni);
    const ffin = Moment(dataEnd);
    return ffin.isAfter(fini, "day");
  },

  passValidation: (string) => {
    const result = {};
    const regxMin = new RegExp("^(?=.{8,})");
    const regxCapital = new RegExp("^(?=.*[A-Z])");
    const regxLower = new RegExp("^(?=.*[a-z])");
    const regxNumber = new RegExp("^(?=.*[0-9])");

    const regxSpecialCaracters = new RegExp(
      "^(?=.*[-#?!@$%^&*,.()+:;<>=[^_`{}|~'/])"
    );
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-#?!@$%^&*,.()+:;<>=[^_`{}|~'/])(?=.{8,})"
    );

    result.regxMin = !!regxMin.test(string);
    result.regxCapital = !!regxCapital.test(string);
    result.regxLower = !!regxLower.test(string);
    result.regxNumber = !!regxNumber.test(string);
    result.regxSpecialCaracters = !!regxSpecialCaracters.test(string);
    result.strongRegex = !!strongRegex.test(string);

    return result;
  },
  formateaRut(rut) {
    const actual = rut.replace(/^0+/, "");
    if (actual !== "" && actual.length > 1) {
      const sinPuntos = actual.replace(/\./g, "");
      const actualLimpio = sinPuntos.replace(/-/g, "");
      const inicio = actualLimpio.substring(0, actualLimpio.length - 1);
      var rutPuntos = "";
      let i = 0;
      let j = 1;
      for (i = inicio.length - 1; i >= 0; i--) {
        const letra = inicio.charAt(i);
        rutPuntos = letra + rutPuntos;
        if (j % 3 === 0 && j <= inicio.length - 1) {
          rutPuntos = `.${rutPuntos}`;
        }
        j++;
      }
      const dv = actualLimpio.substring(actualLimpio.length - 1);
      rutPuntos = `${rutPuntos}-${dv}`;
    }
    return rutPuntos;
  },
  checkDuplicatedDocumentNumber(listEmployees) {
    const rutList = [];

    listEmployees.forEach((obj, i) => {
      if (obj.rutEmpleado) {
        if (obj.rutEmpleado.length >= 8 || obj.rutEmpleado.length <= 12) {
          const formattedRut = validaciones.formateaRut(obj.rutEmpleado);
          rutList.push(formattedRut);
        } else {
          rutList.push(obj.rutEmpleado);
        }
      }
      if (obj.DocumentNumber) {
        if (obj.DocumentNumber.length >= 8 || obj.DocumentNumber.length <= 12) {
          const formattedRut = validaciones.formateaRut(obj.DocumentNumber);
          rutList.push(formattedRut);
        } else {
          rutList.push(obj.DocumentNumber);
        }
      }
    });

    for (let i = 0; i < rutList.length; i++) {
      for (let j = 0; j < rutList.length; j++) {
        if (i !== j) {
          if (
            rutList[i] !== undefined &&
            rutList[j] !== undefined &&
            rutList[i] === rutList[j] &&
            rutList[i] !== "" &&
            rutList[j] !== ""
          ) {
            return true;
          }
        }
      }
    }
    return false;
  },
  getDaysIndex: (day) => {
    const week = [
      { index: 0, name: "domingo", order: 7 },
      { index: 1, name: "lunes", order: 1 },
      { index: 2, name: "martes", order: 2 },
      { index: 3, name: "miércoles", order: 3 },
      { index: 4, name: "jueves", order: 4 },
      { index: 5, name: "viernes", order: 5 },
      { index: 6, name: "sábado", order: 6 },
    ];
    const pivot = week.find((e) => e.name === day);
    return pivot;
  },
  getDaysByOrder: (i) => {
    const week = [
      { index: 0, name: "domingo", order: 7 },
      { index: 1, name: "lunes", order: 1 },
      { index: 2, name: "martes", order: 2 },
      { index: 3, name: "miércoles", order: 3 },
      { index: 4, name: "jueves", order: 4 },
      { index: 5, name: "viernes", order: 5 },
      { index: 6, name: "sábado", order: 6 },
    ];
    const pivot = week.find((e) => e.order === Number(i));
    return pivot;
  },
  getTimeForInterval: (time, interval) => {
    let [hora, minutos] = time.split(":");

    minutos = parseInt(minutos, 10);
    hora = parseInt(hora, 10);
    if (interval === 60) {
      hora += 1;
    } else if (interval === 45 && minutos === 30) {
      hora += 1;
      minutos = 15;
    } else if (interval === 30 && minutos === 30) {
      hora += 1;
      minutos = "00";
    } else {
      minutos += interval;
    }
    return `${hora}:${minutos}`;
  },
  sortComunas: (a, b) => {
    return `${a.DescripcionCommuna}`.localeCompare(`${b.DescripcionCommuna}`);
  },
};

export default validaciones;
